// using CommonJS export because function is used in gatsby-node.js file and runs during node build
module.exports = {
  hasProp: (obj, propName) => {
    return Object.prototype.hasOwnProperty.call(obj, propName);
  }
}
